export const CashbackVoucherStatusesToShow = ['active', 'active_assign', 'generate', 'used']
